// extracted by mini-css-extract-plugin
export var actionButton = "_os-0";
export var actionMenuContainer = "_os-i";
export var bubble = "_os-2";
export var bubbleActionMenu = "_os-j";
export var bubbleContext = "_os-6";
export var bubbleItems = "_os-7";
export var customer = "_os-3";
export var divider = "_os-8";
export var fileList = "_os-9";
export var hiddenComment = "_os-o";
export var infoAbove = "_os-a";
export var internal = "_os-4";
export var lightActionButton = "_os-1";
export var link = "_os-b";
export var merchant = "_os-5";
export var message = "_os-c";
export var profilePicture = "_os-e";
export var quillToolbarContainer = "_os-f";
export var senderDate = "_os-g";
export var senderDateCustomer = "_os-h";
export var senderName = "_os-d";
export var time = "_os-k";
export var uploadedImage = "_os-l";
export var username = "_os-m";
export var xsmall = "_os-n";